'use client'

import { PropsWithChildren } from 'react';

interface CardBoxDefaultProps {
  className?: string;
}

const CardBoxDefault = ({className, children}: PropsWithChildren<CardBoxDefaultProps>) => {
  return (
    <div className={`grid gap-2 p-4 ring-1 ring-gray-100 shadow rounded-lg bg-white ${className}`}>
      {children}
    </div>
  )
}

export default CardBoxDefault;